export const WORDS = [
'wednesday',
'thursday',
'friday',
  'pioneer',
  'abilene',
  'alfalfa',
  'catfish',
  'picnic',
  'brutus',
  'wagon',
  'airplane',
  'sprint',
  'railroad',
  'kansa',
  'huron',
  'jayhawks',
  'dole',
  'livgren',
  'gunsmoke',
  'flint',
  'goodland',
  'olathe',
  'buffalo',
  'heron',
  'gypsum',
  'wichita',
  'brown',
  'haskell',
  'white',
  'tornado',
  'cattle',
  'chisolm',
  'curry',
  'pittsburg',
  'twine',
  'shocker',
  'topeka',
  'parker',
  'bluestem',
  'yucca',
  'holliday',
  'helium',
  'landon',
  'koch',
  'sandzen',
  'coronado',
  'kickapoo',
  'kurtis',
  'hughes',
  'salt',
  'inge',
  'kilby',
  'nation',
  'naismith',
  'riggins',
  'steak',
  'czech',
  'konza',
  'smoky',
  'blackgold',
  'holcomb',
  'earp',
  'glickman',
  'hugoton',
  'hereford',
  'pheasant',
  'muskrat',
  'dockum',
  'padilla',
  'larned',
  'emporia',
  'hunting',
  'wildcat',
  'kapaun',
  'cessna',
  'ichabod',
  'bourbon',
  'monroe',
  'mustang',
  'osage',
  'ottawa',
  'curtis',
  'beaver',
  'sebelius',
  'monument',
  'moran',
  'chrysler',
  'kiowa',
  'coyote',
  'kelly',
  'priddle',
  'pluto',
  'santee',
  'beef',
  'lebanese',
  'quindaro',
  'arkansas',
  'beech',
  'arikaree',
  'fraham',
  'murdock',
  'docking',
  'rodeo',
  'duckwall',
  'quivira',
  'cheyenne',
  'shawnee',
  'yoder',
  'graves',
  'cimmaron',
  'metcalf',
  'angus',
  'plains',
  'pancake',
  'wamego',
  'farmer',
  'stearman',
  'denver',
  'custer',
  'pawnee',
  'clutter',
  'hayden',
  'lawrence',
  'salina',
  'stetson',
  'cobalt',
  'greeley',
  'mcbride',
  'tombaugh',
  'otter',
  'cody',
  'kellogg',
  'blizzard',
  'mushroom',
  'satanta',
  'estes',
  'coal',
  'woodard',
  'frontenac',
  'capper',
  'cozies',
  'amelia',
  'grain',
  'grass',
  'ingalls',
  'sanders',
  'longhorn',
  'newton',
  'dairy',
  'dalton',
  'hays',
  'stover',
  'cromwell',
  'cyrus',
  'hornets',
  'kansas',
  'phog',
  'boeing',
  'bomber',
  'newman',
  'greene',
  'robinson',
  'deer',
  'wheat',
  'garmin',
  'pompeo',
  'jenkins',
  'darby',
  'bobcat',
  'gorillas',
  'mcdaniel',
  'devlin',
  'funston',
  'slattery',
  'eagle',
  'farm',
  'mexican',
  'jeffries',
  'mission',
  'parsons',
  'leoti',
  'solomon',
  'lenexa',
  'midwest',
  'roberts',
  'higley',
  'maxwell',
  'ruffin',
  'amish',
  'milo',
  'hopper',
  'marion',
  'galena',
  'casado',
  'rawlins',
  'riverton',
  'sudekis',
  'hyde',
  'dillons',
  'locusts',
  'ranch',
  'neosho',
  'racoon',
  'trout',
  'wildcats',
  'atchison',
  'capote',
  'lyons',
  'sumner',
  'swedes',
  'victoria',
  'wakarusa',
  'seward',
  'alma',
  'barbeque',
  'bison',
  'bosin',
  'german',
  'sorghum',
  'bleeding',
  'wind',
  'carney',
  'eilert',
  'freddys',
  'latino',
  'tigers',
  'chalk',
  'hawkins',
  'unrau',
  'bethel',
  'davids',
  'perry',
  'alley',
  'specter',
  'comanche',
  'lease',
  'colby',
  'prairie',
  'cassoday',
  'well',
  'brinkley',
  'fairfax',
  'twister',
  'cheney',
  'wizard',
  'friends',
  'keaton',
  'butler',
  'windy',
  'russian',
  'snyder',
  'tiahrt',
  'caldwell',
  'johnson',
  'wilt',
  'dreifort',
  'manning',
  'marshall',
  'eden',
  'norton',
  'hail',
  'toto',
  'tractor',
  'croation',
  'dorothy',
  'liberal',
  'richmond',
  'sand',
  'sexton',
  'douglas',
  'horace',
  'russell',
  'toronto',
  'ellis',
  'hills',
  'storm',
  'strataca',
  'felker',
  'harvey',
  'blackman',
  'tuttle',
  'thunder',
  'garvey',
  'lansing',
  'lark',
  'pistol',
  'carson',
  'italians',
  'lewis',
  'mann',
  'citation',
  'jeffrey',
  'nealy',
  'meade',
  'rainbow',
  'landoll',
  'carter',
  'allen',
  'parks',
  'lane',
  'maize',
  'wallace',
  'ryan',
  'spirit',
  'range',
  'pivot',
  'burnett',
  'goat',
  'tribune',
  'anschutz',
  'combine',
  'carver',
  'meyers',
  'walsh',
  'colt',
  'henson',
  'coleman',
  'silage',
  'pillsbury',
  'nemaha',
  'hartman',
  'self',
  'finney',
  'harper',
  'wilson',
  'highland',
  'zinc',
  'andover',
  'farley',
  'cotton',
  'nichols',
  'probst',
  'rudd',
  'salter',
  'stull',
  'bethany',
  'riggle',
  'riley',
  'coulter',
  'cougar',
  'clark',
  'turtle',
  'bender',
  'engle',
  'pagent',
  'wilder',
  'ross',
  'baker',
  'fried',
  'arvonia',
  'clinton',
  'stiles',
  'strip',
  'castle',
  'benning',
  'chaps',
  'cheese',
  'sugar',
  'tasker',
  'reno',
  'burrell',
  'free',
  'hickok',
  'lead',
  'milford',
  'western'
]